// models to loading from Server
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ProductDetailsDataModel3, ProductDetailsSyncModel, ProductDetailsSyncSingleDataModel3, ProductDataModel4, NutritionViewModel, NutritionItemViewModel, ProductExtraDataModel3, ProductExtraItemViewModel, ProductExtraViewModel, ProductExtraPricesModel, ProductPricesModel, AllProductDetailsSyncModel, AllProductDetailsSyncDataModel3 } from "../shared/models/product.model";
import { SingelDataModelService, ServerCallHelper } from "./singelDataModel.service";
import { ContentType, GetContentDirFromType, TranslationContentType, YourAPPProductType } from "../shared/contentTypes";
import Utils from "../shared/utils";
import { CoreLogService } from "./log.service";
import { LocalKeys, StorageHive, ValueStorageService } from "./valueStorage.service";
import { environment } from "../../../environments/environment";
import { CoreLanguageManager } from "./ILanguageManager";

/** Product Service for ProductDetails */

export class ProductDetailsHelperService {

  /** Gets the ProductsDetails by Product (if change time between Product and Details wrong load it force from server)
   * @param product product of details
   * @param helper helper needs for access
   * @param withServerCall allow download from Server
   * @param force force download from Server (withServerCall must be true for the option)
   * @param suppress_change_at_diff suppress a force download from Server if the change_at of product > than
   */
  public static GetProductDetails(product: ProductDataModel4, helper: CircularInjectionHelper, withServerCall: boolean, force: boolean, suppress_change_at_diff: boolean = false): Promise<ProductDetailsDataModel3> {
    return new Promise<ProductDetailsDataModel3>((resolve, reject) => {
      let server_call_helper: ServerCallHelper<ProductDetailsDataModel3> = null;
      if (withServerCall) {
        const RequestData = new ProductDetailsSyncModel();
        RequestData.id = product.id;
        server_call_helper = new ServerCallHelper<ProductDetailsDataModel3>(RequestData, "menu/GetNewProductDetails3", ProductDetailsSyncSingleDataModel3);
      }
      SingelDataModelService.GetDataModel(ProductDetailsDataModel3, GetContentDirFromType(ContentType.sub_Product), product.id, helper, withServerCall, server_call_helper, force, !force) // (!force) auch als oldByError, denn es wird sofort beim abruf benötigt
        .then(async (productDetails) => {
          // Todo Details vom Server anfordern, wenn changetime der Details vor dem des Product liegen
          // momentanes problem an dieser Lösung, product change_at ist change_at und last_image_update_at und bei details sind es alle sub elemente
          if (!suppress_change_at_diff && !force && (product.change_at > productDetails.change_at)) {
            resolve(await ProductDetailsHelperService.GetProductDetails(product, helper, true, true, false));
          } else {
            resolve(productDetails);
          }
        }).catch((error) => { helper.coreLogService.error("ProductDetailsHelperService.GetProductDetails", "SingelDataModelService.GetDataModel", error); reject(); });
    });
  }

  // durch die Änderung des Nachladens (bei zugriff abgleich der ChangeAt) ist das nicht mehr notwendig (auskommentiert als Beispiel wenn wieder notwendig werden sollte)
  ///** downloads the failing ProductDetails (Attention: See also ModelManagerProduct.postLoadData) */
  //public static DownloadFaildProductDetails(productObsServ: IObjectObserver<ProductDataModel3>, helper: CircularInjectionHelper): Promise<void> {
  //  return new Promise<void>(async (resolve, reject) => {
  //    try {
  //      const products = await productObsServ.GetObjectsByFilter((product) => { return !product.fresh_details; });
  //      if (products.length > 0) {
  //        await Utils.asyncForEach(products, async (product) => {
  //          try {
  //            await ProductDetailsHelperService.GetProductDetails(product, helper, true, true);
  //            product.fresh_details = true;
  //          } catch (error) {
  //            helper.coreLogService.error("ProductDetailsHelperService.DownloadProductDetailsAsync", "GetProductDetails", product.id, error);
  //          }
  //        });
  //        await productObsServ.SetObjectsIntern(products, true, 712468);
  //      }
  //      resolve();
  //    } catch (error) {
  //      helper.coreLogService.error("ProductDetailsHelperService.DownloadProductDetailsAsync", "GetObjectsByFilter", error);
  //      reject();
  //    }
  //  });
  //}

  /** Gets the AllProductsDetails (change time will be  Product and Details wrong load it force from server)
   * @param location gets product details for this location and sortiments
   * @param sortiments gets only product details for the sortiments of the location
   * @param helper helper needs for access
   */
  public static GetAllProductDetails(location: number, sortiments: string[], helper: CircularInjectionHelper, storage: ValueStorageService): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {

      // die products sollten zusammen mit den product details geholt werden (auch mit dem Sortimenten, da das momentan nicht der fall ist so das min sync ermitteln und nutzen)

      // clean up sortiments and sort (to have a key for storage)
      sortiments = sortiments.filter((v, i, a) => a.indexOf(v) === i).sort();

      let lastProductSyncAt = null;
      const last_calls = await storage.get(StorageHive.Local, LocalKeys.sotAllProductDetailsCall);
      if (last_calls && last_calls.locations && last_calls.locations[location]) {
        const last_sortiments = last_calls.locations[location].sortiments;
        if (last_sortiments.length === sortiments.length && last_sortiments.every((value, index) => value === sortiments[index])) {
          lastProductSyncAt = Utils.GetMomentFromInt(last_calls.locations[location].last_sync_at_ymd, last_calls.locations[location].last_sync_at_hms);
        }
      }

      const RequestData = new AllProductDetailsSyncModel();
      RequestData.hyp_cus_nr = location;
      RequestData.sortiments = sortiments;
      if (lastProductSyncAt != null && lastProductSyncAt > RequestData.changes_since) {
        RequestData.changes_since_ymd = Utils.GetYMDFromMoment(lastProductSyncAt);
        RequestData.changes_since_hms = Utils.GetHMSFromMoment(lastProductSyncAt);
      }

      try {
        const response = await helper.yourAppServer.Api.RequestService(AllProductDetailsSyncDataModel3, "menu/GetAllNewProductDetails3", RequestData);
        if (response.OK) {
          // lastProductSyncAt ist null, wenn die Daten neu abgerufen werden, es muss die alten überschreiben, da es ein Massenabruf ist
          // und das request_at aus den abgerufenen Daten ermittelt wird und sich unterscheiden kann.
          const overwrite_old_data = lastProductSyncAt == null;

          // save all product_details
          await Utils.asyncForEach(response.Data.product_details_as_single, async (sync_data) => {
            await SingelDataModelService.SetNewDataModel(ProductDetailsDataModel3, GetContentDirFromType(ContentType.sub_Product), sync_data, helper, overwrite_old_data);
          });
          // save new last sync          
          let calls = (await storage.get(StorageHive.Local, LocalKeys.sotAllProductDetailsCall));
          if (!calls) {
            calls = { locations: {} };
          }
          calls.locations[location] = { sortiments: sortiments, last_sync_at_ymd: response.Data.request_at_ymd, last_sync_at_hms: response.Data.request_at_hms };
          await storage.set(StorageHive.Local, LocalKeys.sotAllProductDetailsCall, calls);

          resolve();
        } else {
          helper.coreLogService.error("ProductDetailsHelperService.GetAllProductDetails", "RequestService (response not OK)", [response, RequestData]);
          reject(response.HttpResponse.codeText);
        }
      } catch (error) {
        helper.coreLogService.error("ProductDetailsHelperService.GetAllProductDetails", "RequestService (error)", error);
        reject();
      }
    });
  }
}

// TODO temporär hier abgelegt
export class ProductDetailsHelper {

  /** map um deutsch in englisch zu übersetzen */
  public static NutritionsMapDeToEn = {
    "Energie/Brennwert": "Energy/Calorific value",
    "Kohlenhydrate": "Carbohydrate",
    "davon Stärke": "thereof Starch",
    "davon Zucker": "thereof Sugar",
    "davon Ballaststoffe": "thereof Fibres",
    "Fettgehalt": "Fat content",
    "davon einfach ungesättigte Fettsäuren": "thereof Monounsaturated fatty acids",
    "davon gesättigte Fettsäuren": "thereof Saturated fatty acids",
    "davon mehrfach ungesättigte Fettsäuren": " thereof Polyunsaturated fatty acid",
    "Cholesterin": "Cholesterol",
    "Natrium (Na)": "Sodium (Na)",
    "Salz": "Salt",
    "Eiweiß": "Protein",
    "Alkohol": "Alcohol",
    "Wasser": "Water",
    "Vitamin A": "Vitamin A",
    "Provitamin A": "Provitamin A",
    "Beta-Carotin activity": "Beta carotene activity",
    "Beta-Carotin": "Beta carotene",
    "Vitamin B1 (Thiamine)": "Vitamin B1 (Thiamine)",
    "Vitamin B2 (Riboflavin)": "Vitamin B2 (Riboflavin)",
    "Vitamin B6 (Pyridoxine)": "Vitamin B6 (Pyridoxine)",
    "Vitamin B12 (Cobalamin)": "Vitamin B12 (Cobalamin)",
    "Niacin": "Niacin",
    "Folsäure": "Folic acid",
    "Pantothensäure": "Pantothenic acid",
    "Vitamin C (Ascorbinsäure )": "Vitamin C (Ascorbic acid )",
    "Vitamin D": "Vitamin D",
    "Vitamin E activity": "Vitamin E activity",
    "Kalium (K)": "Potassium (K)",
    "Chloride (Cl)": "Chlorides (Cl)",
    "Kalzium (Ca)": "Calcium (Ca)",
    "Magnesium (Mg)": "Magnesium (Mg)",
    "Phosphorus (P)": "Phosphor (P)",
    "Eisen (Fe)": "Iron (Fe)",
    "Iodide (I)": "Iodide (I)",
    "ZinK (Zn)": "Zinc (Zn)",
    "Koffein": "Caffeine",
  };

  /** ermittelt aus den */
  public static getNutritionsViewModel(productDetail: ProductDetailsDataModel3, with_de: boolean, with_en: boolean): NutritionViewModel {
    const nutritions: NutritionViewModel = new NutritionViewModel();
    if (with_de) {
      nutritions.headerDE = productDetail.nutrition_title_de;
      const nutritionItemsDE: NutritionItemViewModel[] = [];
      if (productDetail.nutrition_values_de) {
        productDetail.nutrition_values_de.split("\n").forEach(element => {
          const model = new NutritionItemViewModel();
          const item = element.split("\t");
          model.title = item[0];
          model.value = item[1];
          nutritionItemsDE.push(model);
        });
      }
      nutritions.nutritionItemViewModelsDE = nutritionItemsDE;
    }

    if (with_en) {
      let ml = productDetail.nutrition_title_de.indexOf("ml") > 0;
      // Currently hardcoded because the backend only provides the german translations
      nutritions.headerEN = ml ? "Nutritional value per 100ml" : "Nutritional value per 100g"; // nutritions.headerEN = productDetail.nutrition_title_en;
      const nutritionItemsEN: NutritionItemViewModel[] = [];
      if (productDetail.nutrition_values_en) {
        productDetail.nutrition_values_en.split("\n").forEach(element => {
          const model = new NutritionItemViewModel();
          const item = element.split("\t");
          // Translate Nutritional Values using a hardcoded dictionary,
          // since the backend only provides german translations
          if (ProductDetailsHelper.NutritionsMapDeToEn.hasOwnProperty(item[0])) {
            model.title = ProductDetailsHelper.NutritionsMapDeToEn[item[0]];
          } else {
            model.title = item[0]; // keep german
            console.log("getNutritionsViewModel: Couldn't find Translation for: " + item[0]);
          }
          model.value = item[1];
          nutritionItemsEN.push(model);
        });
      }
      nutritions.nutritionItemViewModelsEN = nutritionItemsEN;
    }

    return nutritions;
  }

  /** Extracts Additive and Allergy Keys from a Text
   * @param text string containing Keys (i.e. "*Z1", "*Aa" ,"*Z110" ,"*Aac")
   */
  public static extractAdditivesAndAllergiesKeysFromText(text: string): string[] {
    const keys: string[] = [];
    const regex = RegExp(/\s*\*([ZA][\d\w]+)/, "g");
    let additiveRegEx: string[];
    while ((additiveRegEx = regex.exec(text)) !== null) {
      keys.push(additiveRegEx[1]);
    }
    return keys;
  }

  private static AdditivesAndAllergies: { [id: string]: { [id: string]: string } } = null;
  /** Gets a hardcoded Dictionary that provides Explanations for Additive- and AllergyLabels
   * @param german: if German should be used, otherwise English as default for all other languages.
   */
  private static getAdditivesAndAllergies(useGerman: boolean): { [id: string]: string } {
    if (!ProductDetailsHelper.AdditivesAndAllergies) {
      ProductDetailsHelper.initAdditivesAndAllergies();
    }
    return ProductDetailsHelper.AdditivesAndAllergies[useGerman ? "de" : "en"];
  }

  /** initieren der übersetzungen */
  private static initAdditivesAndAllergies(): void {
    if (ProductDetailsHelper.AdditivesAndAllergies) {
      return; // already init
    }

    ProductDetailsHelper.AdditivesAndAllergies = { "de": {}, "en": {} };

    const _addAdditiveAllergyTranslations = function (label: string, de: string, en: string) {
      ProductDetailsHelper.AdditivesAndAllergies["de"][label] = de;
      ProductDetailsHelper.AdditivesAndAllergies["en"][label] = en;
    };

    // Additives
    _addAdditiveAllergyTranslations("Z1", "Mit Konservierungsstoff", "With preservative");
    _addAdditiveAllergyTranslations("Z2", "Mit Farbstoff", "With artificial colours");
    _addAdditiveAllergyTranslations("Z3", "Mit Antioxidationsmittel", "With antioxidants");
    _addAdditiveAllergyTranslations("Z4", "Mit Süssungsmittel Saccharin", "With sweetener saccharine");
    _addAdditiveAllergyTranslations("Z5", "Mit Süssungsmittel Cyclamat", "With sweetener cyclamate");
    _addAdditiveAllergyTranslations("Z6", "Mit Süssungsmittel Aspartam, enth. Phenylalaninquelle", "With sweetener aspartame, contains a phenylalanine source");
    _addAdditiveAllergyTranslations("Z7", "Mit Süssungsmittel Acesulfam", "With sweetener acesulfam");
    _addAdditiveAllergyTranslations("Z8", "Mit Phosphat", "With phosphate");
    _addAdditiveAllergyTranslations("Z9", "Geschwefelt", "Sulfur-treated");
    _addAdditiveAllergyTranslations("Z10", "Chininhaltig", "Chinin-based");
    _addAdditiveAllergyTranslations("Z11", "Koffeinhaltig", "With caffine");
    _addAdditiveAllergyTranslations("Z12", "Mit Geschmacksverstärker", "With flavour enhancer");
    _addAdditiveAllergyTranslations("Z13", "Geschwärzt", "Blackened");
    _addAdditiveAllergyTranslations("Z14", "Gewachst", "Waxed");
    _addAdditiveAllergyTranslations("Z15", "Gentechnisch verändert", "Genetically modified");
    _addAdditiveAllergyTranslations("Z16", "Mit Milcheiweiß", "With milk protein");
    _addAdditiveAllergyTranslations("Z17", "Zuckeraustauschstoff Sorbit E 420", "Sugar substitutes sorbit E 420");
    _addAdditiveAllergyTranslations("Z18", "Enthält eine Phenylalaninquelle", "Contains a phenylalanine source");
    _addAdditiveAllergyTranslations("Z19", "Mit Süßungsmittel(n)", "With sweetener(s)");
    _addAdditiveAllergyTranslations("Z20", "Mit (einer) Zuckerart(en) und Süßungsmittel(n)", "With (one) sugar type(s) and sweetener(s)");
    _addAdditiveAllergyTranslations("Z21", "Alkoholhaltig", "with alcohol");
    _addAdditiveAllergyTranslations("Z22", "mit Nitritpökelsalz", "with nitrite pickling salt");
    _addAdditiveAllergyTranslations("Z23", "Taurin", "Taurine");
    _addAdditiveAllergyTranslations("Z24", "Inosit", "Inositol");
    _addAdditiveAllergyTranslations("Z25", "Glucuronolacton", "Glucuronolactone");
    _addAdditiveAllergyTranslations("Z100", "Tafelsüße auf der Grundlage von Acesulfam", "Table sweetness based on acesulfam");
    _addAdditiveAllergyTranslations("Z101", "Tafelsüße auf der Grundlage von Advantam", "Table sweetness based on Advantam");
    _addAdditiveAllergyTranslations("Z102", "Tafelsüße auf der Grundlage von Aspartam", "Table sweetness based on aspartame");
    _addAdditiveAllergyTranslations("Z103", "Tafelsüße auf der Grundlage von Aspartam-Acesulfam-Salz", "Table sweetness based on aspartame acesulfame salt");
    _addAdditiveAllergyTranslations("Z104", "Tafelsüße auf der Grundlage von Cyclamat", "Table sweetness based on cyclamate");
    _addAdditiveAllergyTranslations("Z105", "Tafelsüße auf der Grundlage von Neohesperidin DC", "Table sweetness based on Neohesperidin DC");
    _addAdditiveAllergyTranslations("Z106", "Tafelsüße auf der Grundlage von Neotam", "Table sweetness based on Neotam");
    _addAdditiveAllergyTranslations("Z107", "Tafelsüße auf der Grundlage von Saccharin", "Table sweetness based on saccharine");
    _addAdditiveAllergyTranslations("Z108", "Tafelsüße auf der Grundlage von Steviolglycoside \"Stevia\"", "Table sweetness based on steviolglycoside \"stevia\"");
    _addAdditiveAllergyTranslations("Z109", "Tafelsüße auf der Grundlage von Sucralose", "Table sweetness based on sucralose");
    _addAdditiveAllergyTranslations("Z110", "Tafelsüße auf der Grundlage von Thaumatin", "Table sweetness based on thaumatin");
    _addAdditiveAllergyTranslations("Z201", "Farbstoff mit Hinweis - Kann Aktivität und Aufmerksamkeit bei Kindern beeinträchtigen.", "Colouring with warning - May affect activity and attention in children.");
    // Allergy
    _addAdditiveAllergyTranslations("Aa", "Enthält glutenhaltige Getreide (d. h. Weizen, Roggen, Gerste, Hafer, Dinkel, Kamut oder deren Hybridstämme) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (i.e. wheat, rye, barley, oats, spelt, kamut or their hybrid strains) and products derived from them");
    _addAdditiveAllergyTranslations("Ab", "Enthält Krebstiere oder daraus gewonnene Erzeugnisse", "Contains crustaceans or derived products");
    _addAdditiveAllergyTranslations("Ac", "Enthält Eier oder daraus gewonnene Erzeugnisse", "Contains eggs or products derived from them");
    _addAdditiveAllergyTranslations("Ad", "Enthält Fisch oder daraus gewonnene Erzeugnisse", "Contains fish or products derived from it");
    _addAdditiveAllergyTranslations("Ae", "Enthält Erdnüsse oder daraus gewonnene Erzeugnisse", "Contains peanuts or products derived from them");
    _addAdditiveAllergyTranslations("Af", "Enthält Sojabohnen oder  daraus gewonnene Erzeugnisse", "Contains soybeans or products derived from them");
    _addAdditiveAllergyTranslations("Ag", "Enthält Milch oder daraus gewonnene Erzeugnisse (einschließlich Laktose)", "Contains milk or derived products (including lactose)");
    _addAdditiveAllergyTranslations("Ah", "Enthält Schalenfrüchte, d. h. Mandeln, Haselnüsse, Walnüsse, Kaschunüsse, Pekannüsse, Paranüsse, Pistazien, Makadamianüsse, Queenslandnüsse oder daraus gewonnene Erzeugnisse", "Contains nuts, i.e. almonds, hazelnuts, walnuts, cashewnuts, pecans, Brazil nuts, pistachios, macadamia nuts, Queenslanduts or products derived from them");
    _addAdditiveAllergyTranslations("Ai", "Enthält Sellerie oder daraus gewonnene Erzeugnisse", "Contains celery or products derived from it");
    _addAdditiveAllergyTranslations("Aj", "Enthält Senf oder daraus gewonnene Erzeugnisse", "Contains mustard or products derived from it");
    _addAdditiveAllergyTranslations("Ak", "Enthält Sesamsamen und daraus gewonnene Erzeugnisse", "Contains sesame seeds and derived products");
    _addAdditiveAllergyTranslations("Al", "Enthält Schwefeldioxid und Sulfite in Konzentrationen von mehr als 10 mg/kg oder 10 mg/l, ausgedrückt als SO2", "Contains sulphur dioxide and sulphites at concentrations of more than 10 mg/kg or 10 mg/l, expressed as SO2");
    _addAdditiveAllergyTranslations("Am", "Enthält Lupinen und daraus gewonnene Erzeugnisse", "Contains lupins and products derived from them");
    _addAdditiveAllergyTranslations("An", "Enthält Weichtiere und daraus gewonnene Erzeugnisse", "Contains molluscs and products derived from them");
    _addAdditiveAllergyTranslations("Ao", "Enthält glutenhaltiges Getreide ( Weizen) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (wheat) and products derived from it");
    _addAdditiveAllergyTranslations("Ap", "Enthält glutenhaltiges Getreide ( Roggen) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (rye) and products derived from it");
    _addAdditiveAllergyTranslations("Aq", "Enthält glutenhaltiges Getreide (Gerste) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (barley) and products derived from it");
    _addAdditiveAllergyTranslations("Ar", "Enthält glutenhaltiges Getreide ( Hafer) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (oats) and products derived from it");
    _addAdditiveAllergyTranslations("As", "Enthält glutenhaltiges Getreide ( Dinkel) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (spelt) and products derived from it");
    _addAdditiveAllergyTranslations("At", "Enthält glutenhaltiges Getreide (Kamut) und daraus gewonnene Erzeugnisse", "Contains gluten-containing cereals (kamut) and products derived from it");
    _addAdditiveAllergyTranslations("Au", "Enthält Schalenfrüchte (Mandeln) oder daraus gewonnene Erzeugnisse", "Contains nuts (almonds) or products derived from them");
    _addAdditiveAllergyTranslations("Av", "Enthält Schalenfrüchte (Haselnüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (hazelnuts) or products derived from them");
    _addAdditiveAllergyTranslations("Aw", "Enthält Schalenfrüchte (Walnüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (walnuts) or products derived from them");
    _addAdditiveAllergyTranslations("Ax", "Enthält Schalenfrüchte (Kaschunüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (cashewnuts) or products derived from them");
    _addAdditiveAllergyTranslations("Ay", "Enthält Schalenfrüchte (Pekannüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (pecans) or products derived from them");
    _addAdditiveAllergyTranslations("Az", "Enthält Schalenfrüchte (Paranüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (Brazil nuts) or products derived from them");
    _addAdditiveAllergyTranslations("Aaa", "Enthält Schalenfrüchte (Pistazien) oder daraus gewonnene Erzeugnisse", "Contains nuts (pistachios) or products derived from them");
    _addAdditiveAllergyTranslations("Aab", "Enthält Schalenfrüchte (Makadamianüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (macadamia) or products derived from them");
    _addAdditiveAllergyTranslations("Aac", "Enthält Schalenfrüchte (Queenslandnüsse) oder daraus gewonnene Erzeugnisse", "Contains nuts (Queensland nuts) or products derived from them");
    _addAdditiveAllergyTranslations("Aad", "Enthält Säuerungsmittel", "Contains acidifier");
    _addAdditiveAllergyTranslations("Aae", "Enthält Stabilisatoren", "Contains stabilizers");
  }

  /** Builds a string array concattenating descriptions for keys
   * Generated descriptions for keys are seperated by newlines
   * @param keys Array containing keys for allergies or additives
   * @param languagekey "de", "en"
   */
  public static getTranslationsFromAdditivesAndAllergiesKeys(keys: string[], languageKey: string): string[] {
    const dictionary = ProductDetailsHelper.getAdditivesAndAllergies(languageKey === "de");

    let translations: string[] = [];
    for (const key of keys) {
      if (dictionary.hasOwnProperty(key)) {
        translations.push(dictionary[key]);
      } else {
        translations.push(key);
        console.log("getTranslationsFromAdditivesAndAllergiesKeys: Couldn't find translation for key: " + key);
      }
    }
    return translations;
  }

  /** Extras
   * ACHTUNG bei änderung derective/articleCard.GetProductDetailDefaultExtras
   */
  public static createProductExtras(sortiment: string, details: ProductDetailsDataModel3, prices: ProductPricesModel): ProductExtraViewModel[] {
    const extramode = details.extramode;
    const noSortProperty = "NoSort" + sortiment;
    const productExtraViewModels: ProductExtraViewModel[] = [];
    const extrasInSort: ProductExtraDataModel3[] = [];
    const subExtrasInSort: ProductExtraDataModel3[] = [];

    // Partition Extras and SubExtras
    details.extras.filter(extra => !extra[noSortProperty]).forEach(extra => {
      (extra.SubIndex >= 0 ? extrasInSort : subExtrasInSort).push(extra);
    });
    const maxExtra = 16; //maximale Anzahl an Subabfragen
    for (let i = 1; i <= maxExtra; ++i) {
      const productExtraViewModel = new ProductExtraViewModel();
      productExtraViewModel.queryOrder = i;
      if (extramode) {
        productExtraViewModel.forceMode = extramode.getForceMode(i);
        productExtraViewModel.maxChoices = extramode["c" + i];
      } else { // fallback While extramode can be null
        productExtraViewModel.forceMode = false;
        productExtraViewModel.maxChoices = 1;
      }
      productExtraViewModel.extratextID = details.extratext_id;
      const extrastext_de: string = details.extratext_de ? details.extratext_de["q" + i] : [];
      productExtraViewModel.titleDE = (extrastext_de && extrastext_de.length > 0) ? extrastext_de : null;
      const extrastext_en: string = details.extratext_en ? details.extratext_en["q" + i] : [];
      productExtraViewModel.titleEN = (extrastext_en && extrastext_en.length > 0) ? extrastext_en : null;

      productExtraViewModel.productExtraItems = [];

      extrasInSort.forEach(extra => {
        if (extra.getQ(i)) {
          const productExtraItemViewModel = ProductDetailsHelper.mapToProductExtraItemViewModel(extra, prices);
          productExtraViewModel.productExtraItems.push(productExtraItemViewModel);

          if (productExtraItemViewModel.subIndex > 0) {
            const subExtras = subExtrasInSort.filter(subextra => subextra.SubIndex === -extra.SubIndex);
            for (const subextra of subExtras) {
              const subExtraItemViewModel = ProductDetailsHelper.mapToProductExtraItemViewModel(subextra, prices);
              productExtraViewModel.productExtraItems.push(subExtraItemViewModel);
            }
          }
        }
      });

      productExtraViewModels.push(productExtraViewModel);
    }

    return productExtraViewModels.filter(extragroup => extragroup.productExtraItems.length > 0);
  }

  /** extraitem mapping */
  private static mapToProductExtraItemViewModel(extra: ProductExtraDataModel3, prices: ProductPricesModel): ProductExtraItemViewModel {
    const viewModel = new ProductExtraItemViewModel();
    viewModel.id = extra.id;
    viewModel.rez_id = extra.rez_id;
    viewModel.product_id = extra.product_id;
    viewModel.order = extra.sort_nr;
    viewModel.titleDE = extra.title_de;
    viewModel.titleEN = extra.title_en;
    viewModel.subIndex = extra.SubIndex;
    const extraPrice = prices.extras[extra.id];
    viewModel.price = extraPrice.discountPrice;
    viewModel.deposit = extraPrice.deposit;
    return viewModel;
  }

  /** ermittelt die Beste Preisebene
   * @param product auch preise der Extras errechnen
   * @param servicePE Preisebene für den Service (falss null, wird der Artikelpreis verwendet)
   * @param userPE Preisebene für den Kunden/Gast, wenn vorhanden, sonst null
  */
  public static calculateBestPricelevel(product: ProductDataModel4, servicePE: number, userPE: number): number {
    // initial is servicePe the bestPE
    let bestPE = servicePE;
    // User
    if (userPE !== null && userPE !== bestPE && userPE !== -1) { // userPe = -1 > use servicePE
      const userPrice = product.prices.find(p => p.pe === userPE);
      if (userPrice) {
        // Service
        const servicePrice = product.prices.find(p => p.pe === servicePE);
        if (userPrice.extras < (servicePrice ? servicePrice.extras : product.extras)) {
          bestPE = userPE;
        }
      }
    }
    return bestPE;
  }

  /**
   * @param product auch preise der Extras errechnen
   * @param useAH ist Außer Haus Preis
   * @param bestPE beste anzuwendende Preisebene (falss null, wird der Artikelpreis verwendet)
   * @param discountPercent rabatt in prozent
   * @param withExtras auch preise der Extras errechnen
   * @param productDetails wenn withExtras true, productDetails vom product (sonst nicht benötigt)
   * @param coreLogService wenn withExtras true
  */
  public static calculateProductPrices(product: ProductDataModel4,
    useAH: boolean,
    bestPE: number,
    discountPercent: number,
    withExtras: boolean,
    productDetails: ProductDetailsDataModel3,
    coreLogService: CoreLogService): ProductPricesModel {
    const prices = new ProductPricesModel();
    prices.bestPE = bestPE;
    const pePrice = (prices.bestPE != null) ? product.prices.find(p => p.pe === prices.bestPE) : null;
    if (pePrice) {
      prices.price = pePrice.price;
      prices.priceWithExtras = pePrice.extras;
      prices.deposit = (useAH ? pePrice.dep_ah : pePrice.dep);
      prices.depositWithExtras = (useAH ? pePrice.dep_with_extras_ah : pePrice.dep_with_extras);
      prices.vat = (useAH ? pePrice.vat_ah : pePrice.vat);
    } else { // Fallback
      prices.price = product.price;
      prices.priceWithExtras = product.extras;
      prices.deposit = (useAH ? product.dep_ah : product.dep);
      prices.depositWithExtras = (useAH ? product.dep_with_extras_ah : product.dep_with_extras);
      prices.vat = (useAH ? product.vat_ah : product.vat);
    }

    // Discount
    // PoS treats a Discount of Zero like every Item has noDiscount set to true,
    // This matters when the Price of an item is unser the minDiscount thus => discountMult === 1
    if (product.noDiscount || discountPercent === 0) {
      prices.discountPrice = prices.price;
      prices.discountPriceWithExtras = prices.priceWithExtras;
    } else {
      prices.discountPrice = ProductDetailsHelper.applyDiscount(prices.price, discountPercent, product.minDiscountPrice, product.noDiscount);
      prices.discountPriceWithExtras = ProductDetailsHelper.applyDiscount(prices.priceWithExtras, discountPercent, product.minDiscountPrice, product.noDiscount);
    }

    // Calculate Extras
    if (withExtras) {
      if (productDetails) {
        productDetails.extras.forEach(extra => {
          const pricesExtra = new ProductExtraPricesModel();
          if (prices.bestPE != null) {
            const price = extra.prices.find(p => p.pe === prices.bestPE);
            if (price) {
              pricesExtra.price = price.price;
              pricesExtra.deposit = (useAH ? price.dep_ah : price.dep);
            } else {
              coreLogService.error("ProductDetailsHelperService.calculateProductPrices", `Extra with id: ${extra.id} does not have prices for pe:${prices.bestPE}`);
            }
          } else { // Fallback
            pricesExtra.price = extra.price;
            pricesExtra.deposit = (useAH ? extra.dep_ah : extra.dep);
          }
          // Sobald Produktdaten für Extras auch im Webshop beachtet werden, sollte der minDiscout und noDiscount hier eventuell eingebaut werden
          pricesExtra.discountPrice = ProductDetailsHelper.applyDiscount(pricesExtra.price, discountPercent);
          prices.extras[extra.id] = pricesExtra;
        });
      } else {
        coreLogService.error("ProductDetailsHelperService.calculateProductPrices", `withExtras for product id: ${product.id} without productDetails`);
      }
    }
    return prices;
  }

  /** Apply a Discount to a price according to POS Rules
   * @param price price to apply Discount to
   * @param discount the amount of Discount in Percent
   * @param minDiscountPrice the lowest price the discount can reduce to
   * @param noDiscount wether discounts are allowed (will return baseprice if true)
   */
  public static applyDiscount(price: number, discount: number, minDiscountPrice: number = 0, noDiscount: boolean = false): number {
    // Discount
    // PoS treats a Discount of Zero like every Item has noDiscount set to true,
    // This matters when the Price of an item is under the minDiscount thus => discountMult === 1
    if (noDiscount || discount === 0) {
      return price;
    } else {
      // ! How you multiply the discount is important because of floatingpoint imprecision
      // Example: 8.10 * 0.75 = 6.0749999 while 8.10 * 75 / 100 = 6.075
      // After Rounding for 2 digits this would result in either 6.08 or 6.07
      return Utils.moneyRound(Math.min(Math.max(price * (100 - discount) / 100, minDiscountPrice), price));
    }
  }
}
